export const API_PROJECTS_FIELDS = [
    'id',
    'status',
    'sort',
    'project_link',
    'translations',
    'has_project_header_optional_data_right',
    'partners',
    'project_first_type',
    'image_color',
    'brand_logo.id',
    'project_type'
];
